import { Navigation } from "./navigation";
import { Contact } from "./contact";
import { FibCalc } from "./fibCalc";
import JsonData from "../data/data.json";
import { useState, useEffect } from "react";

export const PagCalcFib4 = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Navigation />

      <section className="fib4-wrapper py-1">
        <div className="container">

          {/* Componente da calculadora */}
          <FibCalc />

          {/* Texto explicativo */}
          <article className="fib4-text mt-1">
            <h3>O que é o índice FIB-4?</h3>
            <p>
              O FIB-4 é um índice não invasivo utilizado para estimar o risco de
              fibrose hepática, especialmente em pacientes com doenças hepáticas
              crônicas, como Hepatite C, Hepatite B e Esteatose hepática.
            </p>

            <p>
              O cálculo considera idade, níveis de TGO, TGP e contagem de
              plaquetas, auxiliando médicos na tomada de decisão clínica e na
              necessidade de exames complementares.
            </p>
          </article>
        </div>
      </section>

      <Contact data={landingPageData.Contact} />
    </>
  );
};